export default __webpack_public_path__ + "static/media/7.b4bd0d29.png";